import React, { VFC } from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import T from 'i18n-react';
import { makeStyles } from '@material-ui/core/styles';

import { Props } from '..';
import LazyLoadComponent from '~/src/core/components/LazyLoad/LazyLoadComponent';
import { BUSINESSES } from '../../../routing';
import AuthDialogContextProvider from '../../../components/AuthDialog/AuthDialogContextProvider';
import AppLayout from '../../../Layout/AppLayout';
import Performance from '../../../Performance';
import BusinessListSlick from '../../../Businesses/ListSlick';
import NewsContainer from '../../../News/Container';
import TopSlider from '../organisms/TopSlider';
import Banners from '../organisms/Banners';
import InstagramImages from '../components/InstagramImages';
import CardsLineWrapper from '../molecules/CardsLineWrapper';
import PlanLines from '../organisms/PlanLines';

const TopComponent: VFC<Props> = ({
  plans = [],
  businesses = [],
  news = [],
  authenticated,
  ...headerProps
}: Props) => {
  const classes = useStyles();
  return (
    <AuthDialogContextProvider isLoggedIn={!!authenticated}>
      <AppLayout authenticated={authenticated} {...headerProps}>
        <Wrapper>
          <div className={classes.topSlider}>
            <TopSlider />
          </div>
          <BannerWrapper className={classes.container}>
            <Banners />
          </BannerWrapper>

          <ListLine>
            <PlanLines isAuthenticated={!!authenticated} plans={plans} />
            <CardsLineWrapper
              title={T.translate('homes.businesses')}
              subtitle={T.translate('homes.businessesText')}
              linkProps={{
                href: BUSINESSES,
              }}
            >
              <BusinessListSlick
                businesses={businesses}
                isAuthenticated={authenticated}
              />
            </CardsLineWrapper>
          </ListLine>
        </Wrapper>

        <LazyLoadComponent>
          <div className={classes.instagramWrapper}>
            <div className={clsx('container', classes.containerInstagram)}>
              <InstagramImages />
            </div>
          </div>
        </LazyLoadComponent>

        <div className="container">
          <NewsContainer news={news} top={120} />
          <Performance />
        </div>
      </AppLayout>
    </AuthDialogContextProvider>
  );
};

export default TopComponent;

const useStyles = makeStyles((theme) => ({
  topSlider: {
    position: 'relative',
  },
  container: {
    width: '100%',
    margin: 'auto',
    paddingRight: '15px',
    paddingLeft: '15px',
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  instagramWrapper: {
    marginTop: theme.spacing(15),
    padding: theme.spacing(5, 0, 5),
    backgroundColor: '#ffeecb',
    position: 'relative',
  },
  containerInstagram: {
    '@media (min-width: 700px) and (max-width: 992px)': {
      maxWidth: '720px',
    },
  },
}));

const ListLine = styled.div`
  margin-top: ${({ theme }) => theme.spacing(5)}px;
`;
const BannerWrapper = styled.div`
  /* SPの時は、containerクラスのpaddingを適用しない */
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;
  }
`;
const Wrapper = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
`;
